"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_CARD = void 0;
const cards_types_1 = require("./types/cards-types");
exports.EMPTY_CARD = {
    component: {
        id: '-1',
        displayName: 'Untitled Card',
        description: '',
        created_at: '',
        created_by: '',
        updated_at: '',
        updated_by: '',
        type: cards_types_1.CardComponentType.BAR,
    },
    position: { i: '-1', x: 0, y: 0, w: 3, h: 3, maxH: Infinity, minH: 1, maxW: Infinity, minW: 1 },
};
//# sourceMappingURL=constants.js.map